import dayjs from "dayjs";

export const normalizeWorkHours = (input: any): any => {
  const days = Array(7)
    .fill(null)
    .map((_, index) => {
      const day = input?.[index];

      // Eğer geçerli bir start ve end zamanı varsa, hesapla
      if (day?.start && day?.end) {
        const startTime = dayjs(day.start);
        const endTime = dayjs(day.end);
        const duration = endTime.diff(startTime, "hour", true); // ondalıklı saat

        return {
          enabled: true,
          start: startTime.format("HH:mm"),
          end: endTime.format("HH:mm"),
          duration: duration,
        };
      }

      // Hiçbir bilgi yoksa varsayılan kapalı gün
      return {
        enabled: false,
        start: "",
        end: "",
        duration: 0,
      };
    });

  return days;
};
